import { render, staticRenderFns } from "./ClientImages.vue?vue&type=template&id=07cfa11a"
import script from "./ClientImages.vue?vue&type=script&lang=js"
export * from "./ClientImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports